var map = {
	"./4.png": 9051,
	"./441.png": 587,
	"./NotFound.gif": 5038,
	"./bac.jpg": 6529,
	"./back.jpg": 3648,
	"./background.jpg": 9122,
	"./blank.png": 9719,
	"./doc-line.jpg": 6940,
	"./doc-research.jpg": 4928,
	"./doc-team.png": 4282,
	"./doc-team1.png": 8150,
	"./doc-team2.png": 4620,
	"./doctor.png": 140,
	"./doctor1.png": 1229,
	"./drake.jpeg": 516,
	"./graduated.png": 3535,
	"./happy.png": 2744,
	"./hospital.png": 9325,
	"./lmu.jpg": 4425,
	"./lmu.png": 4152,
	"./locales/de.png": 4517,
	"./locales/en.png": 6971,
	"./main-logo.png": 6210,
	"./main-logo1.png": 919,
	"./med-students.jpg": 3107,
	"./profile_def.png": 8056,
	"./sad.png": 597,
	"./single-doc.jpg": 4903,
	"./stud-team.png": 4783,
	"./stud-team1.png": 7926,
	"./stud1.png": 5278,
	"./student.png": 2458,
	"./student5.png": 3951,
	"./student6.png": 4545,
	"./student7.png": 1772,
	"./student8.png": 3451,
	"./support.png": 6145,
	"./under-cons.jpg": 2260,
	"./uni-logos/Augsburg.jpg": 8208,
	"./uni-logos/Bochum.jpg": 5049,
	"./uni-logos/Bonn.jpg": 7475,
	"./uni-logos/Christian-Albrechts-Universität zu Kiel.jpg": 3452,
	"./uni-logos/Johannes Gutenberg-Universität Mainz.jpg": 6087,
	"./uni-logos/LMU.jpg": 4991,
	"./uni-logos/Philipps-Universität Marburg.jpg": 2104,
	"./uni-logos/RWTH Aachen.jpg": 2671,
	"./uni-logos/TUM.jpg": 5912,
	"./uni-logos/albert_ludwigs_universitaet_freiburg.jpg": 376,
	"./uni-logos/carl_von_ossietzky_university_of_oldenburgNA.jpg": 6274,
	"./uni-logos/eberhard karls universität tübingen.jpg": 9753,
	"./uni-logos/erlangen nürnberg.jpg": 4059,
	"./uni-logos/friedrich_schiller_universitt_jena_.jpg": 8771,
	"./uni-logos/greifswald.jpg": 7883,
	"./uni-logos/göttingen_logo.jpg": 6072,
	"./uni-logos/hamburg.jpg": 1063,
	"./uni-logos/heidelberg.jpg": 4994,
	"./uni-logos/heinrich_heine_universitat_düsseldorf.jpg": 5496,
	"./uni-logos/julius_maximilians_universitat_würzburg.jpg": 3187,
	"./uni-logos/justus-liebig-universität giessen.jpg": 6188,
	"./uni-logos/köln.jpg": 323,
	"./uni-logos/leipzig.jpg": 1298,
	"./uni-logos/lübeck.jpg": 7493,
	"./uni-logos/martin_luther_university_halle_wittenberg_logo.jpg": 5884,
	"./uni-logos/medizinische_hochschule_hannover.jpg": 8272,
	"./uni-logos/otto_von_guericke_university_magdeburg.jpg": 8062,
	"./uni-logos/rostock.jpg": 4110,
	"./uni-logos/tu_dresden.jpg": 5303,
	"./uni-logos/ulm.jpg": 2662,
	"./uni-logos/university_of_münster.jpg": 4577,
	"./uni-logos/university_of_regensburg.jpg": 1331,
	"./uni-logos/universität des saarlandes.jpg": 4690,
	"./videos/doctor.mp4": 5985,
	"./videos/hospital.mp4": 6650,
	"./videos/student.mp4": 6926,
	"./work-in-progress.png": 440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;